import { useState } from 'react';
import useToken from 'hooks/useToken';
import { useToast } from 'context/providers/ToastProvider';

/**
 * Custom hook para manejar comentarios de la orden
 */
const useOrdenComentarios = () => {
    const { token, setToken } = useToken();
    const { showErrorToast } = useToast();
    const [procesandoComentario, setProcesandoComentario] = useState(false);

    /**
     * Guarda un comentario en la orden
     */
    const guardarComentario = async (
        idOrden,
        vComentario,
        idTipoComentario,
        orden,
        onSuccess
    ) => {
        try {
            const response = await fetch(
                "/api/orden/RegistrarComentario?idOrden=" + idOrden +
                "&vComentario=" + encodeURIComponent(vComentario) +
                "&idVendedor=" + orden.idVendedor +
                "&vEmailTrabajo=" + orden.vEmailTrabajo +
                "&vNombreCliente=" + orden.vNombreCliente +
                "&idTipoComentario=" + idTipoComentario,
                {
                    method: 'POST',
                    headers: {
                        'Authorization': 'Bearer ' + token,
                        'Content-Type': 'application/json'
                    }
                }
            );

            if (response.ok) {
                console.log(" ==== REGISTRO DE COMENTARIO ==== ");
                const data = await response.json();
                const comentarioBD = data.table2[0];
                onSuccess?.(comentarioBD);
            } else {
                const errorMsg = response.status + ' ' + response.statusText;
                showErrorToast(errorMsg);
                
                if (response.status === 401) {
                    setToken(null);
                    location.href = "";
                }
            }
        } catch (error) {
            const errorMsg = 'Hubo un problema con la peticion Fetch: ' + error;
            showErrorToast(errorMsg);
            console.log(errorMsg);
        }
    };

    /**
     * Envía un comentario de usuario
     */
    const submitComentario = async (
        idOrden,
        comentario,
        orden,
        onSuccess
    ) => {
        if (!comentario || comentario === '') {
            return;
        }

        setProcesandoComentario(true);

        try {
            const response = await fetch(
                "/api/orden/RegistrarComentario?idOrden=" + idOrden +
                "&vComentario=" + encodeURIComponent(comentario) +
                "&idVendedor=" + orden.idVendedor +
                "&vEmailTrabajo=" + orden.vEmailTrabajo +
                "&vNombreCliente=" + orden.vNombreCliente +
                "&idTipoComentario=1",
                {
                    method: 'POST',
                    headers: {
                        'Authorization': 'Bearer ' + token,
                        'Content-Type': 'application/json'
                    }
                }
            );

            if (response.ok) {
                console.log("========== REGISTRAR COMENTARIO ==========");
                const data = await response.json();
                const comentarioBD = data.table2[0];
                onSuccess?.(comentarioBD);
            } else {
                const errorMsg = response.status + ' ' + response.statusText;
                showErrorToast(errorMsg);
                
                if (response.status === 401) {
                    setToken(null);
                    location.href = "";
                }
            }
        } catch (error) {
            const errorMsg = 'Hubo un problema con la peticion Fetch: ' + error;
            showErrorToast(errorMsg);
            console.log(errorMsg);
        } finally {
            setProcesandoComentario(false);
        }
    };

    return {
        procesandoComentario,
        setProcesandoComentario,
        guardarComentario,
        submitComentario
    };
};

export default useOrdenComentarios;
